export default __webpack_public_path__ + "037684514a623d60a47f94cb4718cab4.svg";